import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { TaskCenterTabs } from '../../constants';

export const containerStyle = css`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const headerStyle = css`
  padding: ${theme.spacing(1.5, 2)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${theme.colors.neutral10};
  border-bottom: 1px solid ${theme.colors.neutral10};
  gap: ${theme.spacing(1)};

  span {
    align-items: center;
    display: flex;
    gap: ${theme.spacing(1)};
  }
`;

export const tabButtonStyle = css`
  // The width calculated shifts the content when on the last tab. Hence subtracting 1px would result in
  // assigning a slight lesser width which does not shift the content when on the last tab
  width: calc((100% - 1px) / ${TaskCenterTabs.length});
  box-sizing: border-box;
`;

export const taskListContainer = css`
  flex: 1;
`;

export const assigneeNameStyle = css`
  width: 70;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
